import { useNavigate } from "react-router-dom";
import {toast} from "react-toastify";

const useErrorHandler = () => {
  const navigate = useNavigate();

  const ErrorHandler = (Error) => {
    const statusCode = Error.response.status;
    if (statusCode === 500) {
      toast.error("An error has occurred!");
    } else if (statusCode === 401) {
      sessionStorage.clear();
      const data = Error.response.data;
      toast.warning(data.Message);
      navigate("/", { replace: true });
    } else if (statusCode === 404 || statusCode === 400) {
      const data = Error.response.data;
      toast.warning(data.Message);
    }
  };

  return {
    ErrorHandler,
  };
};

export default useErrorHandler;
